import { render, staticRenderFns } from "./VRefundOrderList.vue?vue&type=template&id=51e576be&scoped=true"
import script from "./VRefundOrderList.vue?vue&type=script&lang=ts"
export * from "./VRefundOrderList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e576be",
  null
  
)

export default component.exports